import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FooterDataState } from "../../../features/layouts/footerTypes";
import { getAboutUs, getFaq, getShopData } from "./footerApi";
const initialState: FooterDataState = {
  aboutUs: {
    data: {
      data: {
        contact_us: {
          phone_number: "",
          email: "",
        },
        terms: "",
        privacy: "",
        about_us: "",
        refund_policy: "",
        app_url: "",
      },
    },
    loader: false,
  },

  faqs: { data: [], loader: false },
  shopData: { data: [], loader: false },
};

export const getAboutUsAsync = createAsyncThunk(
  "/cms/about-us-info/",
  async () => {
    const response = await getAboutUs();
    return response;
  }
);

export const getFaqAsync = createAsyncThunk("/cms/faqs/", async () => {
  const response = await getFaq();
  return response;
});

export const getShopListAsync = createAsyncThunk("/shops/list/", async () => {
  const response = await getShopData();
  return response;
});

export const footerSlice = createSlice({
  name: "footer",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getAboutUsAsync.pending, (state) => {
        state.aboutUs.loader = true;
      })
      .addCase(getAboutUsAsync.fulfilled, (state, action: any) => {
        state.aboutUs.loader = false;
        state.aboutUs.data = action?.payload?.data || [];
      })
      .addCase(getAboutUsAsync.rejected, (state) => {
        state.aboutUs.loader = false;
      })
      .addCase(getFaqAsync.pending, (state) => {
        state.faqs.loader = true;
      })
      .addCase(getFaqAsync.fulfilled, (state, action: any) => {
        state.faqs.loader = false;
        state.faqs.data = action?.payload?.data || [];
      })
      .addCase(getFaqAsync.rejected, (state) => {
        state.faqs.loader = false;
      })
      .addCase(getShopListAsync.pending, (state) => {
        state.shopData.loader = true;
      })
      .addCase(getShopListAsync.fulfilled, (state, action: any) => {
        state.shopData.loader = false;
        state.shopData.data = action?.payload?.data || [];
      })
      .addCase(getShopListAsync.rejected, (state) => {
        state.shopData.loader = false;
      });
  },
});

export default footerSlice.reducer;
